import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import { connect } from 'react-redux';
import actions from '../../actions';
import { Cell, CellInner, CellIcon } from './CartToolBarCell';

class CartReadonlyToolBar extends React.PureComponent {
  static propTypes = {
    editOrderStep: PropTypes.func,
  };

  static defaultProps = {
    editOrderStep: _.identity,
  };

  onPrevClick = () => this.props.editOrderStep('order');

  render() {
    return (
      <Cell full onClick={this.onPrevClick}>
        <CellInner full>
          <CellIcon suffix icon="chevron-left" />
          修改訂單
        </CellInner>
      </Cell>
    );
  }
}

const { edit: editOrderStep } = actions.orderStep;

export default connect(
  null,
  { editOrderStep }
)(CartReadonlyToolBar);



// WEBPACK FOOTER //
// ./src/components/Cart/CartReadonlyToolBar.js